import modalLayout from '../../styles/modalLayout'

const styles = {
    ...modalLayout,
    headerLabel: {
      marginBottom: 3,
    },
    formError: {
      marginBottom: 3,
    },
    textField: {
      marginBottom: 2,
    },
    buttonContainer: {
      textAlign: 'right',
      paddingTop: 3,
    },
    cancelButton: {
      marginRight: 3,
    },
    progress: {
      paddingTop: 1,
      float: 'right',
    },
    secondaryButton: {
      backgroundColor: 'gray',
      padding: 10,
      margin: 5,
    },
    tabBar: {
      marginBottom: 2,
    },
    bulkHeader: {
      marginBottom: 2,
    },
    bulkMeta: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      color: 'text.secondary',
    },
    statRow: {
      display: 'flex',
      gap: 4,
      marginBottom: 3,
      flexWrap: 'wrap',
    },
    statTile: {
      minWidth: 100,
    },
    statTileValue: {
      fontWeight: 500,
    },
    statTileValueWarn: {
      fontWeight: 500,
      color: 'warning.main',
    },
  }
  export default styles
